module.exports = __webpack_public_path__ + "static/titanLogo-92d3c40df08cc203428e568dbf053f54.jpeg";